module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"学生・卒業生 ログイン画面","sign_in":"ログイン","lock_for_admins":"管理ユーザでキャリアマップをご利用中です。ログアウトする場合はこちらを押してください。","forgot_password":"＞パスワードをお忘れの場合","not_received_mail":"＞新規会員登録用のURLが届かない場合","or":"または","social_login":"ソーシャルアカウントでログインする","sign_up":["会員登録していない方は","こちらから登録","してください。"],"corporation_link":"＞採用担当者様はこちら","save_login_info":"ログイン情報を保存"}}')
  delete Component.options._Ctor
}
